import {
  BUSCAR_BAGAGENS,
  SELECIONAR_BAGAGEM,
  CRIAR_BAGAGEM,
  ALTERAR_BAGAGEM,
  EXCLUIR_BAGAGEM,
  DETERMINAR_PAGINA_ATUAL_BAGAGENS,
  ALTERAR_NUMERO_REGISTROS_POR_PAGINA_BAGAGENS,
  ALTERAR_EXIBICAO_BAGAGEM,
} from '../../actions/bagagem/bagagemActions';

const initialState = {
  lista: [],
  bagagemSelecionada: null,
  paginaAtual: 1,
  registrosPorPagina: 10,
  totalRegistros: 0
};

export default function bagagemReducer(state = initialState, action) {
  switch (action.type) {

    case BUSCAR_BAGAGENS:
      return {
        ...state,
        lista: action.payload.bagagens || [],
        totalRegistros: action.payload.total || 0
      };

    case SELECIONAR_BAGAGEM:
      return {
        ...state,
        bagagemSelecionada: action.payload
      };

    case ALTERAR_EXIBICAO_BAGAGEM:
      return {
        ...state,
        lista: state.lista.map(b =>
          b.id === action.payload.id
            ? { ...b, exibirDetalhe: !b.exibirDetalhe }
            : b
        )
      }

    case CRIAR_BAGAGEM:
      return {
        ...state,
        lista: [...state.lista, action.payload]
      };

    case ALTERAR_BAGAGEM:
      return {
        ...state,
        lista: state.lista.map(b =>
          b.id === action.payload.id ? action.payload : b
        )
      };

    case EXCLUIR_BAGAGEM:
      return {
        ...state,
        lista: state.lista.filter(b => b.id !== action.payload)
      };

    case DETERMINAR_PAGINA_ATUAL_BAGAGENS:
      return {
        ...state,
        paginaAtual: action.payload
      };

    case ALTERAR_NUMERO_REGISTROS_POR_PAGINA_BAGAGENS:
      return {
        ...state,
        registrosPorPagina: action.payload
      };

    default:
      return state;
  }
}
